import { makeStyles } from '@mui/styles';
import { theme } from '~/theme/default';
export const useStyles = makeStyles(() => ({
    bookContainer: {
        position: 'relative',
    },
    image: {
        zIndex: 1,
        width: '88px',
    },
    description: {
        height: '28px',
        width: '88px',
        position: 'absolute',
        top: '64px',
        background: theme.palette.background.default,
        zIndex: 2,
        left: '10px',
        padding: '2px',
        borderTop: `solid 1px ${theme.palette.grey.A100}`,
        borderBottom: `solid 1px ${theme.palette.grey.A100}`,
    },
    descriptionContent: {
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textAlign: 'center',
    },
    descriptionTitle: {
        '&.MuiTypography-root': {
            fontSize: '10px',
        },
    },
    descriptionPeriod: {
        '&.MuiTypography-root': {
            fontSize: '6px',
        },
    },
    imageContainer: {
        borderTop: `solid 1px ${theme.palette.grey.A100}`,
        borderBottom: `solid 1px ${theme.palette.grey.A100}`,
        width: '90px',
        height: '100px',
        background: theme.palette.grey['50'],
        textAlign: 'right',
    },
}));
